import { useCallback, useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

/* Menu déroulant local, partagé par les filtres, le sélecteur de colonnes et
   les vues enregistrées. Échap et le clic extérieur ferment ; la touche est
   arrêtée dans le conteneur pour ne pas fermer aussi le panneau parent. */
export default function Popover({
  label, icon: Icon, children, align = "right", trigger, triggerClass = "adm-btn is-sm",
  title, disabled, testid, menuClass = "", chevron = true, width,
}) {
  const [open, setOpen] = useState(false);
  const root = useRef(null);
  const close = useCallback(() => setOpen(false), []);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = event => { if (root.current && !root.current.contains(event.target)) setOpen(false); };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);

  const onKeyDown = event => {
    if (event.key === "Escape" && open) {
      event.stopPropagation();
      event.preventDefault();
      setOpen(false);
      root.current?.querySelector("button")?.focus();
    }
  };

  return (
    <span className="adm-pop" ref={root} onKeyDown={onKeyDown}>
      {trigger
        ? trigger({ open, toggle: () => setOpen(v => !v) })
        : (
          <button
            type="button"
            className={triggerClass}
            aria-expanded={open}
            aria-haspopup="true"
            disabled={disabled}
            title={title}
            onClick={() => setOpen(v => !v)}
            data-testid={testid}
          >
            {Icon && <Icon size={13} />}
            {label}
            {chevron && <ChevronDown size={12} />}
          </button>
        )}
      {open && (
        <div
          className={`adm-menu${align === "left" ? " is-left" : ""} ${menuClass}`}
          role="dialog"
          aria-label={title || (typeof label === "string" ? label : "Menu")}
          style={width ? { width } : undefined}
        >
          {typeof children === "function" ? children({ close }) : children}
        </div>
      )}
    </span>
  );
}
